import * as React from "react";
import * as PropTypes from "prop-types";

interface IProps {
    children?: any;
}

export class Actions extends React.PureComponent<IProps, any> {
    static contextTypes = {
        app: PropTypes.any.isRequired,
    };

    componentDidMount() {
        this.context.app.trigger("header:actions", this.props.children);
    }

    componentDidUpdate() {
        this.context.app.trigger("header:actions", this.props.children);
    }

    componentWillUnmount() {
        this.context.app.trigger("header:actions", null);
    }

    render() {
        return null;
    }
}
